<span *ngFor="let practice of practices;" [ngbTooltip]="tooltip" container="body">
  <span class="ctag" [ngClass]="practice.c_name" [style.background-color]="!practice.is_visible ? '#ACAAAA' : ''"
    [style.color]="!practice.is_visible ? '#737272' : ''">
    <ng-template #tooltip>
      <span [innerHTML]="practice.name"></span>
    </ng-template>
    {{practice.name | slice:0:1|uppercase}}
  </span>
</span>